import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toNumber } from "lodash/lang";
import windowSize from 'react-window-size';
import { compose } from 'recompose';
import * as _ from "lodash";

import withAuthorization from '../auth/withAuthorization';
import { createClue, editClue, fetchClueIcons } from "../../actions/index";
import { renderField, renderArea } from "../common_page_elements";
import SetMapBounds, { centerOfBounds } from "../huntcomponents/UpdateBoundsOnMap";
import {
   googleBoundsToFirebaseBounds,
   googleLatLngToFirebaseGeopoint
} from "../../helper_functions";
import ClueIconChooser, { getIconUrl } from "./ClueIconChooser";
import { BOUNDS } from "../../constants/Game";
import { TEXT, DURATION_MIN, CODE, CLUE_LATLON } from "../../constants/Clue";

import '../../global.css';
import './ClueEdit.css'

import {
   clueExplanationCode1,
   clueExplanationCode2,
   clueEndingParagraphCode,
   clueFurtherExplanation,
   clueFurtherExplanationParagraph2,
   clueFurtherExplanationParagraph3,
   clueFurtherExplanationParagraph4,
   clueFurtherExplanationParagraph5
} from "../../constants/Strings";
import { deleteFileInFbStorage, PhotoUpload, processFile, thumbName } from "../image/PhotoUpload";
import { ButtonFileInput } from "../image/SimpleFileInput";
import { updateClue } from "../../actions";

// For validation of fields
const number = value =>
   value && isNaN(Number(value)) ? 'Must be a number' : undefined;

/**
 * New Clue or Edit Clue.
 * Consisting mainly of a few form elements and plenty of explanation.
 * Plus now a map for most clues.
 * */
class ClueEdit extends Component {

   constructor(props) {
      super(props);

      this.state = {
         initialClueValues: _.cloneDeep(this.props.clue),          // copy of initial clue state
         changesMade: false,          // whether any changes have been made on this page
         unsavedChanges: false,       // whether we have any unsaved changes
         savedChanges: false,
         filesToDeleteOnDone: [],     // list of URLs to delete on Google Storage when done.
         filesToDeleteOnCancel: [],   // list of URLs to delete on Google Storage when user reverts changes.

         boundsRect: null,            // a google.maps.Rectangle (used in new clue)
         clueMarker: null,            // a google.maps.Marker    (used in new clue)
         iconName: null,              // name of OTH icon    (used in new clue)
         clue_picture: null,          //  (used in new clue)
         clue_thumb: null,            //  (used in new clue)
         answer_photo: null,          //  (used in new clue)
         answer_thumb: null,          //  (used in new clue)
         trackedUserLocation: null,   // used in setting location with GPS location.
         watchId: null,               // // used in finding GPS location.  todo: Does this work at all?
         loadingClueImage: false,      // whether upload spinner visible for picture clue
         loadingAnswerPhoto: false     // whether upload spinner visible for answer photo
      };

      this.onCancel = this.onCancel.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.setBoundsRect = this.setBoundsRect.bind(this);
      this.setClueMarker = this.setClueMarker.bind(this);
      this.iconClicked = this.iconClicked.bind(this);
      this.trackUserLocation = this.trackUserLocation.bind(this);
      this.setUserLocation = this.setUserLocation.bind(this);
      this.locationNo = this.locationNo.bind(this);
      this.onDropClueImageFile = this.onDropClueImageFile.bind(this);
      this.clueImageUploadComplete = this.clueImageUploadComplete.bind(this);
      this.errorUploadingPhoto = this.errorUploadingPhoto.bind(this);
      this.changeMade = this.changeMade.bind(this);
      this.mapChange = this.mapChange.bind(this);
      this.finish = this.finish.bind(this);
      this.exit = this.exit.bind(this);
   }

   componentDidMount() {
      window.scrollTo(0, 0);
      this.trackUserLocation();
   }

   componentWillUnmount() {
      if (this.state.watchId) {
         navigator.geolocation.clearWatch(this.state.watchId);
      }
   }

   changeMade(unsaved = false, saved = false) {
      const newUnsavedState = this.state.unsavedChanges || unsaved;
      const newSavedState = this.state.savedChanges || saved;
      this.setState({changesMade: true, unsavedChanges: newUnsavedState, savedChanges: newSavedState});
   }

   // occurs on page map load, or when map first clicked to set marker/bounds
   setBoundsRect(rect, startup = false) {

      this.setState({boundsRect: rect});

      if (!startup && !!this.props.clue) this.mapChange();
   }

   // occurs on page map load, or when map first clicked to set marker/bounds
   setClueMarker(marker, startup = false) {
      this.setState({clueMarker: marker, trackedUserLocation: { coords: { latitude: 0, longitude: 0 } } });
      navigator.geolocation.clearWatch(this.state.watchId);

      if (!startup && !!this.props.clue) this.mapChange();
   }

   // occurs when existing bounds or marker position changes.
   mapChange() {
      if (!!this.props.clue) {
         const marker = this.state.clueMarker;
         const markerLatLon = !!marker ? googleLatLngToFirebaseGeopoint(marker.getPosition()) : null;

         const rect = this.state.boundsRect;
         const rectLatLonBounds = !!rect ? googleBoundsToFirebaseBounds(rect.getBounds()) : null;

         this.update(
            { latlon : markerLatLon, boundingBox: rectLatLonBounds },
            () => { }
         )
         this.changeMade(false, true);
      } else {
         this.changeMade(true, false);
      }
   }

   // User clicks on clue icon choice
   iconClicked(name) {
      const { clue } = this.props;

      if (!!clue) {
         this.update(
            { icon : name },
            () => { }
         )
      } else {
         this.setState({iconName: name});
      }

      const savedChanges = !!clue;
      this.changeMade(!savedChanges, savedChanges)
   }

   trackUserLocation() {
      if ("geolocation" in navigator) {
         const geo_options = {
            enableHighAccuracy: true
         };

         const watchId = navigator.geolocation.watchPosition(this.setUserLocation, this.locationNo, geo_options);
         this.setState( {watchId : watchId})
      } else {
         console.log("No location for this device");
      }
   }

   setUserLocation(position) {
      this.setState( { trackedUserLocation: position.coords });
   }

   locationNo(error) {
      console.log("Error getting location: " + error.message);
      this.setState( { trackedUserLocation: null });
   }

   // callback from photo upload.
   clueImageUploadComplete(newUrl, imageProperty, thumbUrl, thumbProperty) {

      const newOnCancelArray = !!newUrl ? _.concat(this.state.filesToDeleteOnCancel, newUrl, thumbUrl) : this.state.filesToDeleteOnCancel;

      const { clue } = this.props;
      if (!clue) {
         this.setState( { loadingClueImage: false, loadingAnswerPhoto: false,
               [imageProperty]: newUrl, [thumbProperty]: thumbUrl,
            filesToDeleteOnCancel : newOnCancelArray, unsavedChanges: true } );
         return;
      }

      if (newUrl == null && clue[imageProperty] == null) {
         this.setState( { loadingClueImage: false, loadingAnswerPhoto: false } )
         return;
      }

      const values = { [imageProperty]: newUrl, [thumbProperty]: thumbUrl };
      const callback = () => {
         this.setState( { loadingClueImage: false,  loadingAnswerPhoto: false,
            filesToDeleteOnCancel : newOnCancelArray,
            savedChanges: !!newUrl, changesMade: !!newUrl })};

      this.update(values, callback)
   }

   // callback from PhotoUpload
   errorUploadingPhoto(errorMsg) {
      this.setState( { loadingClueImage: false, loadingAnswerPhoto: false } )

      if (!!errorMsg) {
         alert(errorMsg)
      }
   }

   // callback from file chooser for image upload
   onDropClueImageFile(files, imageProperty) {

      const file = files[0]
      if (!file) {
         return;
      }

      // this will trigger file processing and image upload by PhotoUpload component.
      if (imageProperty === 'answer_photo') {
         this.setState( { loadingAnswerPhoto: true } )
      } else {
         this.setState( { loadingClueImage: true } )
      }
      const thumbProperty = thumbName(imageProperty);
      const game = this.game();
      processFile(file,
         imageProperty, thumbProperty,
         game.id, game.authorId,
         game.isPublic,
         game.created,
         this.clueImageUploadComplete, this.errorUploadingPhoto )
   }

   // delete excess files and exit
   finish() {
      this.state.filesToDeleteOnDone.forEach( (fileUrl) => {
         deleteFileInFbStorage(fileUrl);
      });

      this.exit();
   }

   // go back to game
   exit() {
      const {history} = this.props;
      history.goBack();
   }

   // User clicks cancel (i.e. changes have occurred but they want to cancel out)
   onCancel() {
      if (!this.props.clue || !this.state.savedChanges) {
         this.exit()
      } else {
         // deletes any new uploaded files we're not going to use
         this.state.filesToDeleteOnCancel.forEach( (fileUrl) => {
            deleteFileInFbStorage(fileUrl);
         });

         // prepares this.state so onSubmit handles this case correctly
         Object.assign(this.state, {
            boundsRect: null,
            clueMarker: null,
            iconName: null,
            clue_picture: null,
            clue_thumb: null,
            answer_photo: null,
            answer_thumb: null,
            unsavedChanges: true
         });

         // this should reset all saved state for this clue to what is was when we started editing.  Call history.goBack()
         this.onSubmit(this.state.initialClueValues);
      }
   }

   update(values, callback) {
      const id = this.id();
      const game = this.props.games[id];
      const { clue } = this.props;

      updateClue(game,
         clue,
         values,
         callback);
   }

   // User clicks on submit
   onSubmit(values) {
      if (!this.state.unsavedChanges) {
         this.exit();
         return;
      }

      const {clue, history, createClue, editClue} = this.props;
      const id = this.id();
      const game = this.props.games[id];
      game.id = id;

      const callback = () => {
         history.goBack();
      };

      // clear out discarded values
      // if (!values.time_released) delete values[DURATION_MIN];
      // if (!values.code_released) delete values[CODE];

      // Set clue lat-lon & bounds, even if null.
      const marker = this.state.clueMarker;
      const rect = this.state.boundsRect;

      if (marker) {
         values[CLUE_LATLON] = googleLatLngToFirebaseGeopoint(marker.getPosition());
      }
      if (rect) {
         values.boundingBox = googleBoundsToFirebaseBounds(rect.getBounds());
      }

      // if an icon selection was made, save it.
      if (!!this.state.iconName) {
         values.icon = this.state.iconName;
      }

      // add the images if we've saved them in state.
      if (!!this.state.clue_picture) {
         values.clue_picture = this.state.clue_picture;
      }
      if (!!this.state.clue_thumb) {
         values.clue_thumb = this.state.clue_thumb;
      }
      if (!!this.state.answer_photo) {
         values.answer_photo = this.state.answer_photo;
      }
      if (!!this.state.answer_thumb) {
         values.answer_thumb = this.state.answer_thumb;
      }

      if (!values.duration_min
         || isNaN(Number(values.duration_min))) {
         delete values.duration_min;
      } else {
         const number = Number(values.duration_min);
         const tooSmall = number < 0.1;
         if (tooSmall) {
            delete values.duration_min;
         } else {
            values.duration_min = Number(values.duration_min);
         }
      }

      if (clue) {
         // maintain image values -- since editClue replaces all values in clue
         if (!!clue.answer_photo && !values.answer_photo)  values.answer_photo = clue.answer_photo;
         if (!!clue.answer_thumb && !values.answer_thumb) values.answer_thumb = clue.answer_thumb;
         if (!!clue.clue_picture && !values.clue_picture) values.clue_picture = clue.clue_picture;
         if (!!clue.clue_thumb && !values.clue_thumb) values.clue_thumb = clue.clue_thumb;

         editClue(game, values, clue, callback);
      } else {
         createClue(game, values, callback);
      }
   }

   estimateMapDimensions() {

      const minDimensions = {width: 280, height: 200};
      const {windowWidth} = this.props;

      let width = Math.max(windowWidth * 64 / 100, minDimensions.width);
      let height = Math.max(windowWidth * 48 / 100, minDimensions.height);

      width = Math.min(width, 396);
      height = Math.min(height, 310);

      return {width, height}
   }

   // helper to grab the game id
   id() {
      return this.props.match.params.id;
   }

   // helper to grab the game
   game() {
      const {games} = this.props;
      return games[this.id()];
   }

   isNewGame() {
      return this.props.match.params.isnewgame;
   }

   hasIndex() {
      return !!this.props.match.params.index
   }

   // Clue number is the clue index, if any, plus one.
   clueNumber() {
      if (!this.hasIndex()) return null;
      return toNumber(this.props.match.params.index) + 1
   }

   pageTitle() {
      const { clue } = this.props;
      return clue ? "Edit Clue" : "New Clue";
   }

   buttonText() {
      const { clue } = this.props;
      return clue ? "Update" : "Create";
   }

   clueTitle() {
      return this.hasIndex()
         ? "Clue #" + this.clueNumber()
         : "Clue";
   }

   render() {
      const { handleSubmit, games, history, clue, clueIcons } = this.props;
      const { changesMade, unsavedChanges } = this.state;
      const finishText = 'Use `Finish` to save text.'

      if (!games || !this.game()) {
         return (
            <div>
               <button
                  onClick={() => {
                     history.goBack();
                  }}
                  className="btn btn-link">
                  Return to clues page to reset state.
               </button>
            </div>
         )
      }

      if (!clueIcons) {
         fetchClueIcons()
      }

      // Map
      const gameBounds = this.game()[BOUNDS];
      const bounds = clue ? clue.boundingBox : null;   // name in database
      const boundsForScale = bounds ? bounds : gameBounds;
      const {width, height} = this.estimateMapDimensions();
      const {centerLat, centerLon} = centerOfBounds(gameBounds);
      const hasLocReading = !!centerLat;

      const geopoint = clue ? clue[CLUE_LATLON] : null;

      const cluePicture = clue ? clue.clue_picture : !!this.state.clue_picture ? this.state.clue_picture : null;
      const answerPhoto = clue ? clue.answer_photo : !!this.state.answer_photo ? this.state.answer_photo : null;
      const pictureButtonText = "Choose image";

      const clueLat = geopoint ? geopoint.latitude : null;
      const clueLon = geopoint ? geopoint.longitude : null;

      const chosenIconUrl = getIconUrl(clueIcons, clue, this.state, true);

      return (
         <div className='editor'>

            <form onSubmit={handleSubmit(this.onSubmit)}>

            <FinishButtons
               isNewClue={!!clue}
               changesMade={changesMade}
               exit={this.exit}
               cancel={this.onCancel}
               />

            <div>
               <div className="pull-right top-padding right-margin text-primary">
                  <h4 className="user">
                     {this.game().title}
                  </h4>
               </div>
               <h2 className="top-padding left-margin bottom-margin">
                  {this.pageTitle()}
               </h2>
            </div>

            <p className="left-margin secondary-text">
               {clueExplanationCode1}
            </p>

            <p className="bottom-margin left-margin secondary-text">
               {clueExplanationCode2}
            </p>

            <h5 className="clear-all big-top-margin left-margin">{this.clueTitle()} picture</h5>

            <div className="pull-right col-xs-12 col-sm-5 lighter-highlight">
               <p>Optional.  You can use a photo or illustration as a hint to solving this clue. </p>
               <p>If taking a picture on your phone, shoot in landscape (sideways) so photo doesn't appear rotated. </p>
            </div>

            <div className="col-xs-10 col-sm-7 small-bottom-margin">
               <PhotoUpload
                  url={cluePicture}
                  loading={this.state.loadingClueImage}
                  editable={true}
                  deletedCallback={() => this.clueImageUploadComplete(null, 'clue_picture', null, 'clue_thumb')}
                  errorCallback={this.errorUploadingPhoto}
               />
            </div>
            <div className="top-margin small-bottom-margin clear-left left-margin">
               <ButtonFileInput
                  labelText={pictureButtonText}
                  onChange={this.onDropClueImageFile}
                  accept="image/*"
                  id="clue_picture"
               />
            </div>

            <h5 className="clear-all big-top-margin left-margin">{this.clueTitle()} text</h5>

               <div className="pull-right col-xs-12 col-sm-5 lighter-highlight">
                  <p>The text is usually the heart of the clue.  Along with the clue picture, it leads to the specific location and
                     text of the answer code.  It can be a riddle the user has to solve, or simply tell the user exactly where to go to find
                     the answer. </p>
               </div>

               <div className="bottom-margin col-xs-12 col-sm-7">

                  <Field
                     onChange={() => this.changeMade(true)}
                     name={TEXT}
                     type="textarea"
                     component={renderArea}
                     clueWidth={true}
                     rows={7}
                     placeholder="The clue!"
                  />
                  { (!!clue && !!unsavedChanges) &&
                  <div className="clear-left darkred-text bottom-margin" >{finishText}</div>
                  }
               </div>

               <h5 className="clear-all top-margin bottom-margin left-margin">Clue Location & Bounds</h5>

               <div className="pull-right col-xs-12 col-sm-5 lighter-highlight">
                  <p>Optional.  Zoom in, pan around, and click on the exact location of the answer to place it on the map. </p>
                  <p>You can move the marker around as needed to get it just right.  Users will depend on this when they get the Reveal Location hint.</p>
                  <p>The <i>search bounds</i> appears as well when you place the marker.  Drag this bounds around
                     and resize it to make as desired for helping your user to the vicinity of the clue answer.</p>
                  <p>You should keep your clue location and bounds inside the hunt bounds. Otherwise your users
                     will get confused.</p>
                  <p>The blue dot, if present, indicates your current position.  Use it to find the right clue location or for reference.</p>
               </div>

               <div className="big-bottom-margin col-xs-12 col-sm-7">
                  <SetMapBounds
                     forClue={true}
                     bounds={bounds}
                     height={height}
                     width={width}
                     clueLat={clueLat}
                     clueLon={clueLon}
                     lonDefault={centerLon}
                     boundsForScale={boundsForScale}
                     outsideBounds={gameBounds}
                     hasDefaultLatLon={hasLocReading}
                     userCoords={this.state.trackedUserLocation}
                     boundsRectCallback={this.setBoundsRect}
                     clueMarkerCallback={this.setClueMarker}
                     mapChangeCallback={this.mapChange}
                     onCancelCallback={this.onCancel}
                     allowClear={true}/>
               </div>

               <h5 className="clear-all big-top-margin left-margin">Answer</h5>

               <div className="pull-right col-xs-12 col-sm-5 lighter-highlight">
                  <p>The user enters this text, the answer code, to advance. </p>
               </div>

               {/*<div className="big-left-margin big-right-margin">*/}
               <div className="bottom-margin col-xs-12 col-sm-7">

               <Field
                           name={CODE}
                           onChange={ () => this.changeMade(true) }
                           type="text"
                           component={renderField}
                           placeholder="code to enter"
                        />
               </div>

               <h5 className="clear-all big-top-margin left-margin">Photo of answer</h5>

               <div className="pull-right col-xs-12 col-sm-5 lighter-highlight">
                  <p>Optional.  A photo of the answer in its location.  If the user never locates the answer, and
                     times out or "skips clue", this shows them where it was.  This reassures a person who can't find
                     your answer, and also enables the user to repair a broken clue or notify you if something is wrong.</p>
                  <p>If taking a picture on your phone, shoot in landscape (sideways) so photo doesn't appear rotated. </p>
               </div>

               <div className="col-xs-10 col-sm-7 small-bottom-margin">
                  <PhotoUpload
                     url={answerPhoto}
                     loading={this.state.loadingAnswerPhoto}
                     editable={true}
                     deletedCallback={() => this.clueImageUploadComplete(null, 'answer_photo', null, 'answer_thumb')}
                     errorCallback={this.errorUploadingPhoto}
                  />
               </div>
               <div className="top-margin small-bottom-margin clear-left left-margin">
                  <ButtonFileInput
                     labelText={pictureButtonText}
                     onChange={this.onDropClueImageFile}
                     accept="image/*"
                     id="answer_photo"
                  />
               </div>

               <h5 className="clear-all big-top-margin left-margin">Time (minutes)</h5>

               <div className="pull-right col-xs-12 col-sm-5 lighter-highlight">
                  <p>Optional duration to release the next clue for free. </p>
               </div>

               <div className="bottom-margin col-xs-12 col-sm-7">
                  <Field
                     name={DURATION_MIN}
                     onChange={ () => this.changeMade(true) }
                     type="number"
                     component={renderField}
                     size={4}
                     placeholder="0"
                     validate={[number]}
                  />
               </div>

               <h5 className="clear-all big-top-margin left-margin">Clue icon</h5>

               <div className="pull-right col-xs-12 col-sm-5 lighter-highlight small-top-margin">
                  <p>Choose an icon to go with this clue.  This icon is placed next to the clue text during the hunt, and
                     it may relate to the location of the clue, something in the text, the clue answer, or nothing
                     at all.  It's up to you.  This icon is mainly for looks.</p>
               </div>

               <div className="col-xs-12 col-sm-7">

                  <div className="align-center small-bottom-margin" >
                     <img className="chosen-icon" src={chosenIconUrl} alt="chosen clue icon"/>
                  </div>

                  <ClueIconChooser iconList={clueIcons} callback={this.iconClicked}/>
               </div>

               <p className="bottom-margin clear-all secondary-text">Of course, you can come back and edit everything in this clue after it's created, in any browser.</p>

               <FinishButtons
                  isNewClue={!!clue}
                  changesMade={changesMade}
                  exit={this.exit}
                  cancel={this.onCancel}
               />
            </form>
            <p className="demphasized-text big-top-margin">{ clueFurtherExplanation }
            </p><p className="demphasized-text"> { clueFurtherExplanationParagraph2 }
         </p><p className="demphasized-text">
            {clueEndingParagraphCode}
         </p><p className="demphasized-text"> { clueFurtherExplanationParagraph3 }
         </p><p className="demphasized-text"> { clueFurtherExplanationParagraph4 }
         </p><p className="demphasized-text"> { clueFurtherExplanationParagraph5 }
         </p>
         </div>
      );
   }
}

const FinishButtons = ( props ) => {

   const { isNewClue, changesMade, exit, cancel } = props;

   const doneText   = isNewClue ? "Finish" : "Finish"
   const backText   = isNewClue ? "Back to game"       : "Back to game";
   const revertText = isNewClue ? "Undo"               : "Cancel"

   return (
      <div>
         {!changesMade &&
         <button
            type="button"
            onClick={exit}
            className="btn accent-link bottom-margin">
            {backText}
         </button>
         }
         {changesMade &&
         <button
            type="submit"
            className="btn-lg btn-default bottom-margin small-left-margin">
            <span className="primary-link">{doneText}</span>
         </button>
         }
         {changesMade &&
         <button
            type="button"
            onClick={cancel}
            className="btn-lg btn-default bottom-margin left-margin">
            <span className="revert-link">{revertText}</span>
         </button>
         }
      </div>
   )
};

// revert-link


// boilerplate redux, tie in our app state to props
const authCondition = (authUser) => !!authUser;

// Decorate with reduxForm(). It will read the initialValues prop provided by connect()
ClueEdit = reduxForm({
   form: 'NewClueForm' // a unique identifier for this form
})(
   connect(null, {createClue, editClue}
   )(ClueEdit));

// Decorate with connect to read form values
const selector = formValueSelector('NewClueForm');
ClueEdit = connect(state => {
   // can select values individually
   const durationSelectedValue = selector(state, 'time_released');
   const codeSelectedValue = selector(state, 'code_released');
   return {
      durationSelectedValue,
      codeSelectedValue
   }
})(ClueEdit);

function mapStateToProps(state) {
   return {
      initialValues: state.selectedClue, // pull initial values from account reducer
      games: state.games,
      clue: state.selectedClue,
      clueIcons: state.clueIcons
   }
}

export default compose(
   withAuthorization(authCondition),
   connect(mapStateToProps, {createClue, editClue, updateClue}),
   withRouter,
   windowSize
)(ClueEdit);


// WEBPACK FOOTER //
// ./src/components/clues/ClueEdit.js